<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div class="container" [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey">
    <header class="header">
        <div class="siklu-logo"></div>
        <h1 id="dialog-title" class="dialog-title">
            {{ 'emailVerification.title' | translate }}
        </h1>
        <p id="dialog-subtitle" class="dialog-subtitle">
            {{ 'emailVerification.subtitle' | translate : {length: tokenLength()} }}
        </p>
    </header>
    <main class="card-content">
        @if (!isTemporaryBlocked()) {
            <section>
                <winde-email-verification-input
                        [(token)]="token"
                        [tokenLength]="tokenLength()">
                </winde-email-verification-input>
            </section>
            <section>
                <div class="button-group">
                    <button type="button"
                            windeGreen
                            class="verify-button"
                            [disabled]="!canVerify() || isValidating() || isEmailVerified()"
                            (click)="validateToken()">
                        <span>{{ verifyButtonText() | translate }}</span>
                    </button>
                    <button type="button"
                            windeTransparent
                            class="resend-button"
                            [attr.tabindex]="0"
                            [disabled]="isValidating() || isEmailVerified()"
                            (click)="generateNewTokenAndSendToEmail()">
                        <span>{{ resendButtonText() | translate }}</span>
                    </button>
                </div>
            </section>
        }
        <section>
            @if (errorMessage(); as error) {
                <div class="message error-message">
                    {{ error.message | translate : error.params }}
                </div>
            }
            @if (infoMessage(); as info) {
                <div class="message info-message">
                    {{ info.message | translate : info.params }}
                </div>
            }
            @if (successMessage(); as success) {
                <div class="message success-message">
                    {{ success.message | translate : success.params }}
                </div>
            }
        </section>
    </main>
</div>
